/*!

=========================================================
* Vue Argon Dashboard Laravel - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vue-argon-dashboard-laravel
* Copyright Creative Tim (https://www.creative-tim.com) & UPDIVISION (https://www.updivision.com)

* Coded by www.creative-tim.com & www.updivision.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import axios from "axios";
import VueAxios from "vue-axios";
import VueLayers from 'vuelayers'
import vSelect from 'vue-select'
import * as VueGoogleMaps from 'vue2-google-maps'


import 'vuelayers/lib/style.css' // needs css-loader
// Import Swiper styles
import 'swiper/swiper.scss';
import 'vue-select/dist/vue-select.css';
/*Custom*/
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import * as x5GMaps from 'x5-gmaps';

const moment = require('moment')
require('moment/locale/es')

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


Vue.use(VueLayers);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment'), {
  moment
});
Vue.component('v-select', vSelect);

Vue.config.productionTip = false

window.axios = axios;
//AIzaSyBmUgeXBUJSkAxptY4tIGYwLcfUUyTqCtE
//AIzaSyCa6w0bHBTR2-tDB3w-_sX7aZp-4gUVUFQ
//Vue.use(x5GMaps, 'AIzaSyDwN1EuiNgGe_8CNo3xg6e6MqaZcu2PiKU');
// Option 2: With libraries
Vue.use(x5GMaps, { key: 'AIzaSyCPJeBt8grlIlRHNCMSmOjFoZ8Q03mYzS4', libraries: ['places'] });



Vue.use(ArgonDashboard)
const app = new Vue({
  router: router,
  store: store,
  el: "#app",
  render: h => h(App)
});

store.$app = app;